export default __webpack_public_path__ + "static/media/aboutme.0972ad46.png";